import paymentApi from '@/api/payment'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  totals: [],
  totalCount: 0,
  receiverAvailable: false,
  loading: false,
  loaded: false,
}

const getters = {}

const actions = {
  async fetchList({ commit }, filters) {
    commit('SET_LOADING')
    try {
      const { data } = await paymentApi.getCallbacks({
        status: filters.status || undefined,
        search: filters.search || undefined,

        restaurantIds: filters.restaurantIds && filters.restaurantIds.length
          ? filters.restaurantIds
          : undefined,
        skip: (filters.pageNumber - 1) * filters.pageSize,
        take: filters.pageSize,
      })
      commit('SET_LIST', data)
    } catch {
      commit('SET_LIST', {
 receiverAvailable: false, items: [], total: 0, totals: [],
})
    }
  },
}

const mutations = {
  SET_LOADING(state) {
    state.loading = true
  },
  SET_LIST(state, data) {
    state.list = data.items || []
    state.totals = data.totals || []
    state.totalCount = data.total || 0
    state.receiverAvailable = data.receiverAvailable
    state.loading = false
    state.loaded = true
  },
  ...generateFormHandlerMutations(state),
}

const modules = {}

const watchers = []

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
